/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BorrowerContractualizationResponse,
  CreateBorrowerRealEstateCommand,
  CreateLoanDto,
  CreateOrUpdateEmprunteurPersonneResponse,
  CreateOrUpdateMinimalBorrowerPersonCommandDto,
  ErrorResponse,
  GetBorrowerContractDetailsResponse,
  GetBorrowerContractFunnelsCommand,
  GetBorrowerContractFunnelsResponse,
  GetBorrowerLoansResponse,
  GetBorrowerPricingDataDto,
  GetBorrowerProjectInfosResponse,
  GetGroupSelectionResponse,
  GetSpecialConditionsResponse,
  OperationResponse,
  UpdateBorrowerProjectCommand,
  UpdateBorrowerRealEstateCommand,
  UpdateLoanDto,
  UpdateLoanInsuranceCommand,
  UpdateSpecialConditionsCommand,
  UpsertBorrowerPersonCommandDto,
} from '../models/index';
import {
    BorrowerContractualizationResponseFromJSON,
    BorrowerContractualizationResponseToJSON,
    CreateBorrowerRealEstateCommandFromJSON,
    CreateBorrowerRealEstateCommandToJSON,
    CreateLoanDtoFromJSON,
    CreateLoanDtoToJSON,
    CreateOrUpdateEmprunteurPersonneResponseFromJSON,
    CreateOrUpdateEmprunteurPersonneResponseToJSON,
    CreateOrUpdateMinimalBorrowerPersonCommandDtoFromJSON,
    CreateOrUpdateMinimalBorrowerPersonCommandDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetBorrowerContractDetailsResponseFromJSON,
    GetBorrowerContractDetailsResponseToJSON,
    GetBorrowerContractFunnelsCommandFromJSON,
    GetBorrowerContractFunnelsCommandToJSON,
    GetBorrowerContractFunnelsResponseFromJSON,
    GetBorrowerContractFunnelsResponseToJSON,
    GetBorrowerLoansResponseFromJSON,
    GetBorrowerLoansResponseToJSON,
    GetBorrowerPricingDataDtoFromJSON,
    GetBorrowerPricingDataDtoToJSON,
    GetBorrowerProjectInfosResponseFromJSON,
    GetBorrowerProjectInfosResponseToJSON,
    GetGroupSelectionResponseFromJSON,
    GetGroupSelectionResponseToJSON,
    GetSpecialConditionsResponseFromJSON,
    GetSpecialConditionsResponseToJSON,
    OperationResponseFromJSON,
    OperationResponseToJSON,
    UpdateBorrowerProjectCommandFromJSON,
    UpdateBorrowerProjectCommandToJSON,
    UpdateBorrowerRealEstateCommandFromJSON,
    UpdateBorrowerRealEstateCommandToJSON,
    UpdateLoanDtoFromJSON,
    UpdateLoanDtoToJSON,
    UpdateLoanInsuranceCommandFromJSON,
    UpdateLoanInsuranceCommandToJSON,
    UpdateSpecialConditionsCommandFromJSON,
    UpdateSpecialConditionsCommandToJSON,
    UpsertBorrowerPersonCommandDtoFromJSON,
    UpsertBorrowerPersonCommandDtoToJSON,
} from '../models/index';

export interface CreateBorrowerRealEstateRequest {
    createBorrowerRealEstateCommand: CreateBorrowerRealEstateCommand;
}

export interface CreateLoanRequest {
    createLoanDto: CreateLoanDto;
}

export interface CreateOrUpdateMinimalBorrowerPersonRequest {
    borrowerProjectId: string;
    createOrUpdateMinimalBorrowerPersonCommandDto: CreateOrUpdateMinimalBorrowerPersonCommandDto;
}

export interface DeleteBorrowerRequest {
    borrowerProjectId: string;
    borrowerId: string;
}

export interface DeleteLoanRequest {
    loanId: string;
}

export interface GetBorrowerContractDetailsRequest {
    contractId: string;
    includeQuestionnaire?: boolean;
}

export interface GetBorrowerLoansRequest {
    borrowerId: string;
}

export interface GetBorrowerProjectByIdRequest {
    borrowerProjectId: string;
}

export interface GetBorrowerProjectPersonRequest {
    borrowerProjectId: string;
    personId: string;
    includeQuestions: boolean;
}

export interface GetContractFunnelsRequest {
    borrowerProjectId: string;
    getBorrowerContractFunnelsCommand: GetBorrowerContractFunnelsCommand;
    borrowerId?: string;
}

export interface GetGroupSelectionRequest {
    borrowerProjectId: string;
    currentEmprunteurId: string;
}

export interface GetSpecialConditionsByQuoteIdRequest {
    quoteId: string;
}

export interface InitBorrowerPricingProcessRequest {
    borrowerProjectId: string;
    emprunteurId?: string;
}

export interface LinkRealEstateToBorrowerProjectRequest {
    borrowerProjectId: string;
    realEstateId: string;
}

export interface ProcessSpecialConditionsRequest {
    updateSpecialConditionsCommand: UpdateSpecialConditionsCommand;
}

export interface ToggleBorrowerLoanRequest {
    borrowerLoanId: string;
}

export interface UpdateBorrowerProjectRequest {
    borrowerProjectId: string;
    updateBorrowerProjectCommand: UpdateBorrowerProjectCommand;
}

export interface UpdateBorrowerRealEstateRequest {
    realEstateId: string;
    updateBorrowerRealEstateCommand: UpdateBorrowerRealEstateCommand;
}

export interface UpdateLoanRequest {
    loanId: string;
    updateLoanDto: UpdateLoanDto;
}

export interface UpdateLoanContractualizationRequest {
    loanId: string;
    updateLoanInsuranceCommand: UpdateLoanInsuranceCommand;
}

export interface UpsertBorrowerPersonRequest {
    borrowerProjectId: string;
    upsertBorrowerPersonCommandDto: UpsertBorrowerPersonCommandDto;
}

/**
 * 
 */
export class BorrowersApi extends runtime.BaseAPI {

    /**
     * Create Borrower Projects
     */
    async createBorrowerProjectRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/emprunteurs/projets-emprunts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Create Borrower Projects
     */
    async createBorrowerProject(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createBorrowerProjectRaw(initOverrides);
        return await response.value();
    }

    /**
     * Create a real estate property in the borrower context
     */
    async createBorrowerRealEstateRaw(requestParameters: CreateBorrowerRealEstateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createBorrowerRealEstateCommand'] == null) {
            throw new runtime.RequiredError(
                'createBorrowerRealEstateCommand',
                'Required parameter "createBorrowerRealEstateCommand" was null or undefined when calling createBorrowerRealEstate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/emprunteurs/projets-emprunts/bien-immobilier`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBorrowerRealEstateCommandToJSON(requestParameters['createBorrowerRealEstateCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Create a real estate property in the borrower context
     */
    async createBorrowerRealEstate(requestParameters: CreateBorrowerRealEstateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createBorrowerRealEstateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create Loan
     */
    async createLoanRaw(requestParameters: CreateLoanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['createLoanDto'] == null) {
            throw new runtime.RequiredError(
                'createLoanDto',
                'Required parameter "createLoanDto" was null or undefined when calling createLoan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/prets`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLoanDtoToJSON(requestParameters['createLoanDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Create Loan
     */
    async createLoan(requestParameters: CreateLoanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createLoanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates or updates a borrower person with minimal information (name, email, birthDate) and questionnaire responses. Uses minimal DTOs to improve frontend UX.
     * Create or update a minimal borrower person
     */
    async createOrUpdateMinimalBorrowerPersonRaw(requestParameters: CreateOrUpdateMinimalBorrowerPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['borrowerProjectId'] == null) {
            throw new runtime.RequiredError(
                'borrowerProjectId',
                'Required parameter "borrowerProjectId" was null or undefined when calling createOrUpdateMinimalBorrowerPerson().'
            );
        }

        if (requestParameters['createOrUpdateMinimalBorrowerPersonCommandDto'] == null) {
            throw new runtime.RequiredError(
                'createOrUpdateMinimalBorrowerPersonCommandDto',
                'Required parameter "createOrUpdateMinimalBorrowerPersonCommandDto" was null or undefined when calling createOrUpdateMinimalBorrowerPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/emprunteurs/projets-emprunts/{borrowerProjectId}/personnes/minimal`.replace(`{${"borrowerProjectId"}}`, encodeURIComponent(String(requestParameters['borrowerProjectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateOrUpdateMinimalBorrowerPersonCommandDtoToJSON(requestParameters['createOrUpdateMinimalBorrowerPersonCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Creates or updates a borrower person with minimal information (name, email, birthDate) and questionnaire responses. Uses minimal DTOs to improve frontend UX.
     * Create or update a minimal borrower person
     */
    async createOrUpdateMinimalBorrowerPerson(requestParameters: CreateOrUpdateMinimalBorrowerPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.createOrUpdateMinimalBorrowerPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a borrower from a project
     */
    async deleteBorrowerRaw(requestParameters: DeleteBorrowerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['borrowerProjectId'] == null) {
            throw new runtime.RequiredError(
                'borrowerProjectId',
                'Required parameter "borrowerProjectId" was null or undefined when calling deleteBorrower().'
            );
        }

        if (requestParameters['borrowerId'] == null) {
            throw new runtime.RequiredError(
                'borrowerId',
                'Required parameter "borrowerId" was null or undefined when calling deleteBorrower().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/emprunteurs/projets-emprunts/{borrowerProjectId}/emprunteurs/{borrowerId}`.replace(`{${"borrowerProjectId"}}`, encodeURIComponent(String(requestParameters['borrowerProjectId']))).replace(`{${"borrowerId"}}`, encodeURIComponent(String(requestParameters['borrowerId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Delete a borrower from a project
     */
    async deleteBorrower(requestParameters: DeleteBorrowerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.deleteBorrowerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a Loan
     */
    async deleteLoanRaw(requestParameters: DeleteLoanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['loanId'] == null) {
            throw new runtime.RequiredError(
                'loanId',
                'Required parameter "loanId" was null or undefined when calling deleteLoan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/prets/{loanId}`.replace(`{${"loanId"}}`, encodeURIComponent(String(requestParameters['loanId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Delete a Loan
     */
    async deleteLoan(requestParameters: DeleteLoanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.deleteLoanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the full details of a borrower contract including subscriber info, loans with pricing and guarantees, special conditions and optionally the survey answers.
     * Get borrower contract details
     */
    async getBorrowerContractDetailsRaw(requestParameters: GetBorrowerContractDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBorrowerContractDetailsResponse>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getBorrowerContractDetails().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeQuestionnaire'] != null) {
            queryParameters['includeQuestionnaire'] = requestParameters['includeQuestionnaire'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/emprunteurs/contrats/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBorrowerContractDetailsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the full details of a borrower contract including subscriber info, loans with pricing and guarantees, special conditions and optionally the survey answers.
     * Get borrower contract details
     */
    async getBorrowerContractDetails(requestParameters: GetBorrowerContractDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBorrowerContractDetailsResponse> {
        const response = await this.getBorrowerContractDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get loans for a borrower
     */
    async getBorrowerLoansRaw(requestParameters: GetBorrowerLoansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBorrowerLoansResponse>> {
        if (requestParameters['borrowerId'] == null) {
            throw new runtime.RequiredError(
                'borrowerId',
                'Required parameter "borrowerId" was null or undefined when calling getBorrowerLoans().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/emprunteurs/{borrowerId}/prets`.replace(`{${"borrowerId"}}`, encodeURIComponent(String(requestParameters['borrowerId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBorrowerLoansResponseFromJSON(jsonValue));
    }

    /**
     * Get loans for a borrower
     */
    async getBorrowerLoans(requestParameters: GetBorrowerLoansRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBorrowerLoansResponse> {
        const response = await this.getBorrowerLoansRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Borrower project by Id
     */
    async getBorrowerProjectByIdRaw(requestParameters: GetBorrowerProjectByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBorrowerProjectInfosResponse>> {
        if (requestParameters['borrowerProjectId'] == null) {
            throw new runtime.RequiredError(
                'borrowerProjectId',
                'Required parameter "borrowerProjectId" was null or undefined when calling getBorrowerProjectById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/emprunteurs/projets-emprunts/{borrowerProjectId}`.replace(`{${"borrowerProjectId"}}`, encodeURIComponent(String(requestParameters['borrowerProjectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBorrowerProjectInfosResponseFromJSON(jsonValue));
    }

    /**
     * Get Borrower project by Id
     */
    async getBorrowerProjectById(requestParameters: GetBorrowerProjectByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBorrowerProjectInfosResponse> {
        const response = await this.getBorrowerProjectByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get borrowers project person by ID
     */
    async getBorrowerProjectPersonRaw(requestParameters: GetBorrowerProjectPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpsertBorrowerPersonCommandDto>> {
        if (requestParameters['borrowerProjectId'] == null) {
            throw new runtime.RequiredError(
                'borrowerProjectId',
                'Required parameter "borrowerProjectId" was null or undefined when calling getBorrowerProjectPerson().'
            );
        }

        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling getBorrowerProjectPerson().'
            );
        }

        if (requestParameters['includeQuestions'] == null) {
            throw new runtime.RequiredError(
                'includeQuestions',
                'Required parameter "includeQuestions" was null or undefined when calling getBorrowerProjectPerson().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeQuestions'] != null) {
            queryParameters['includeQuestions'] = requestParameters['includeQuestions'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/emprunteurs/projets-emprunts/{borrowerProjectId}/personnes/{personId}`.replace(`{${"borrowerProjectId"}}`, encodeURIComponent(String(requestParameters['borrowerProjectId']))).replace(`{${"personId"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpsertBorrowerPersonCommandDtoFromJSON(jsonValue));
    }

    /**
     * Get borrowers project person by ID
     */
    async getBorrowerProjectPerson(requestParameters: GetBorrowerProjectPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpsertBorrowerPersonCommandDto> {
        const response = await this.getBorrowerProjectPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get borrower contract funnels
     */
    async getContractFunnelsRaw(requestParameters: GetContractFunnelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBorrowerContractFunnelsResponse>> {
        if (requestParameters['borrowerProjectId'] == null) {
            throw new runtime.RequiredError(
                'borrowerProjectId',
                'Required parameter "borrowerProjectId" was null or undefined when calling getContractFunnels().'
            );
        }

        if (requestParameters['getBorrowerContractFunnelsCommand'] == null) {
            throw new runtime.RequiredError(
                'getBorrowerContractFunnelsCommand',
                'Required parameter "getBorrowerContractFunnelsCommand" was null or undefined when calling getContractFunnels().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/emprunteurs/projets-emprunts/{borrowerProjectId}/personnes/{borrowerId}`.replace(`{${"borrowerProjectId"}}`, encodeURIComponent(String(requestParameters['borrowerProjectId']))).replace(`{${"borrowerId"}}`, encodeURIComponent(String(requestParameters['borrowerId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetBorrowerContractFunnelsCommandToJSON(requestParameters['getBorrowerContractFunnelsCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBorrowerContractFunnelsResponseFromJSON(jsonValue));
    }

    /**
     * Get borrower contract funnels
     */
    async getContractFunnels(requestParameters: GetContractFunnelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBorrowerContractFunnelsResponse> {
        const response = await this.getContractFunnelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get group selection for insureds (MNCAP limits to 2 insureds max)
     */
    async getGroupSelectionRaw(requestParameters: GetGroupSelectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetGroupSelectionResponse>> {
        if (requestParameters['borrowerProjectId'] == null) {
            throw new runtime.RequiredError(
                'borrowerProjectId',
                'Required parameter "borrowerProjectId" was null or undefined when calling getGroupSelection().'
            );
        }

        if (requestParameters['currentEmprunteurId'] == null) {
            throw new runtime.RequiredError(
                'currentEmprunteurId',
                'Required parameter "currentEmprunteurId" was null or undefined when calling getGroupSelection().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentEmprunteurId'] != null) {
            queryParameters['currentEmprunteurId'] = requestParameters['currentEmprunteurId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/emprunteurs/projets-emprunts/{borrowerProjectId}/groupe-selection`.replace(`{${"borrowerProjectId"}}`, encodeURIComponent(String(requestParameters['borrowerProjectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetGroupSelectionResponseFromJSON(jsonValue));
    }

    /**
     * Get group selection for insureds (MNCAP limits to 2 insureds max)
     */
    async getGroupSelection(requestParameters: GetGroupSelectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetGroupSelectionResponse> {
        const response = await this.getGroupSelectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get special conditions by quote Id
     */
    async getSpecialConditionsByQuoteIdRaw(requestParameters: GetSpecialConditionsByQuoteIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSpecialConditionsResponse>> {
        if (requestParameters['quoteId'] == null) {
            throw new runtime.RequiredError(
                'quoteId',
                'Required parameter "quoteId" was null or undefined when calling getSpecialConditionsByQuoteId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/emprunteurs/conditions-particulieres/devis/{quoteId}`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters['quoteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetSpecialConditionsResponseFromJSON(jsonValue));
    }

    /**
     * Get special conditions by quote Id
     */
    async getSpecialConditionsByQuoteId(requestParameters: GetSpecialConditionsByQuoteIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSpecialConditionsResponse> {
        const response = await this.getSpecialConditionsByQuoteIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Init borrower pricing interface
     */
    async initBorrowerPricingProcessRaw(requestParameters: InitBorrowerPricingProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBorrowerPricingDataDto>> {
        if (requestParameters['borrowerProjectId'] == null) {
            throw new runtime.RequiredError(
                'borrowerProjectId',
                'Required parameter "borrowerProjectId" was null or undefined when calling initBorrowerPricingProcess().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['emprunteurId'] != null) {
            queryParameters['emprunteurId'] = requestParameters['emprunteurId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/emprunteurs/projets-emprunts/{borrowerProjectId}/init-comparateur`.replace(`{${"borrowerProjectId"}}`, encodeURIComponent(String(requestParameters['borrowerProjectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBorrowerPricingDataDtoFromJSON(jsonValue));
    }

    /**
     * Init borrower pricing interface
     */
    async initBorrowerPricingProcess(requestParameters: InitBorrowerPricingProcessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBorrowerPricingDataDto> {
        const response = await this.initBorrowerPricingProcessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Link an existing real estate property to a borrower project
     */
    async linkRealEstateToBorrowerProjectRaw(requestParameters: LinkRealEstateToBorrowerProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['borrowerProjectId'] == null) {
            throw new runtime.RequiredError(
                'borrowerProjectId',
                'Required parameter "borrowerProjectId" was null or undefined when calling linkRealEstateToBorrowerProject().'
            );
        }

        if (requestParameters['realEstateId'] == null) {
            throw new runtime.RequiredError(
                'realEstateId',
                'Required parameter "realEstateId" was null or undefined when calling linkRealEstateToBorrowerProject().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/emprunteurs/projets-emprunts/{borrowerProjectId}/bien-immobilier/{realEstateId}`.replace(`{${"borrowerProjectId"}}`, encodeURIComponent(String(requestParameters['borrowerProjectId']))).replace(`{${"realEstateId"}}`, encodeURIComponent(String(requestParameters['realEstateId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Link an existing real estate property to a borrower project
     */
    async linkRealEstateToBorrowerProject(requestParameters: LinkRealEstateToBorrowerProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.linkRealEstateToBorrowerProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Process special conditions
     */
    async processSpecialConditionsRaw(requestParameters: ProcessSpecialConditionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['updateSpecialConditionsCommand'] == null) {
            throw new runtime.RequiredError(
                'updateSpecialConditionsCommand',
                'Required parameter "updateSpecialConditionsCommand" was null or undefined when calling processSpecialConditions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/emprunteurs/conditions-particulieres`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateSpecialConditionsCommandToJSON(requestParameters['updateSpecialConditionsCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Process special conditions
     */
    async processSpecialConditions(requestParameters: ProcessSpecialConditionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.processSpecialConditionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Borrower project by Id
     */
    async toggleBorrowerLoanRaw(requestParameters: ToggleBorrowerLoanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['borrowerLoanId'] == null) {
            throw new runtime.RequiredError(
                'borrowerLoanId',
                'Required parameter "borrowerLoanId" was null or undefined when calling toggleBorrowerLoan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/backoffice/prets/prets-emprunteurs/{borrowerLoanId}`.replace(`{${"borrowerLoanId"}}`, encodeURIComponent(String(requestParameters['borrowerLoanId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Get Borrower project by Id
     */
    async toggleBorrowerLoan(requestParameters: ToggleBorrowerLoanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.toggleBorrowerLoanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update Borrower project
     */
    async updateBorrowerProjectRaw(requestParameters: UpdateBorrowerProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['borrowerProjectId'] == null) {
            throw new runtime.RequiredError(
                'borrowerProjectId',
                'Required parameter "borrowerProjectId" was null or undefined when calling updateBorrowerProject().'
            );
        }

        if (requestParameters['updateBorrowerProjectCommand'] == null) {
            throw new runtime.RequiredError(
                'updateBorrowerProjectCommand',
                'Required parameter "updateBorrowerProjectCommand" was null or undefined when calling updateBorrowerProject().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/emprunteurs/projets-emprunts/{borrowerProjectId}`.replace(`{${"borrowerProjectId"}}`, encodeURIComponent(String(requestParameters['borrowerProjectId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBorrowerProjectCommandToJSON(requestParameters['updateBorrowerProjectCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Update Borrower project
     */
    async updateBorrowerProject(requestParameters: UpdateBorrowerProjectRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updateBorrowerProjectRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a real estate property in the borrower context
     */
    async updateBorrowerRealEstateRaw(requestParameters: UpdateBorrowerRealEstateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['realEstateId'] == null) {
            throw new runtime.RequiredError(
                'realEstateId',
                'Required parameter "realEstateId" was null or undefined when calling updateBorrowerRealEstate().'
            );
        }

        if (requestParameters['updateBorrowerRealEstateCommand'] == null) {
            throw new runtime.RequiredError(
                'updateBorrowerRealEstateCommand',
                'Required parameter "updateBorrowerRealEstateCommand" was null or undefined when calling updateBorrowerRealEstate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/emprunteurs/bien-immobilier/{realEstateId}`.replace(`{${"realEstateId"}}`, encodeURIComponent(String(requestParameters['realEstateId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateBorrowerRealEstateCommandToJSON(requestParameters['updateBorrowerRealEstateCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Update a real estate property in the borrower context
     */
    async updateBorrowerRealEstate(requestParameters: UpdateBorrowerRealEstateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updateBorrowerRealEstateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a Loan
     */
    async updateLoanRaw(requestParameters: UpdateLoanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperationResponse>> {
        if (requestParameters['loanId'] == null) {
            throw new runtime.RequiredError(
                'loanId',
                'Required parameter "loanId" was null or undefined when calling updateLoan().'
            );
        }

        if (requestParameters['updateLoanDto'] == null) {
            throw new runtime.RequiredError(
                'updateLoanDto',
                'Required parameter "updateLoanDto" was null or undefined when calling updateLoan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/prets/{loanId}`.replace(`{${"loanId"}}`, encodeURIComponent(String(requestParameters['loanId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLoanDtoToJSON(requestParameters['updateLoanDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperationResponseFromJSON(jsonValue));
    }

    /**
     * Update a Loan
     */
    async updateLoan(requestParameters: UpdateLoanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperationResponse> {
        const response = await this.updateLoanRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update loan contractualization and trigger pricing recalculation
     */
    async updateLoanContractualizationRaw(requestParameters: UpdateLoanContractualizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BorrowerContractualizationResponse>> {
        if (requestParameters['loanId'] == null) {
            throw new runtime.RequiredError(
                'loanId',
                'Required parameter "loanId" was null or undefined when calling updateLoanContractualization().'
            );
        }

        if (requestParameters['updateLoanInsuranceCommand'] == null) {
            throw new runtime.RequiredError(
                'updateLoanInsuranceCommand',
                'Required parameter "updateLoanInsuranceCommand" was null or undefined when calling updateLoanContractualization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/prets/{loanId}/contractualisation`.replace(`{${"loanId"}}`, encodeURIComponent(String(requestParameters['loanId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLoanInsuranceCommandToJSON(requestParameters['updateLoanInsuranceCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BorrowerContractualizationResponseFromJSON(jsonValue));
    }

    /**
     * Update loan contractualization and trigger pricing recalculation
     */
    async updateLoanContractualization(requestParameters: UpdateLoanContractualizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BorrowerContractualizationResponse> {
        const response = await this.updateLoanContractualizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add person to a borrower project
     */
    async upsertBorrowerPersonRaw(requestParameters: UpsertBorrowerPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateOrUpdateEmprunteurPersonneResponse>> {
        if (requestParameters['borrowerProjectId'] == null) {
            throw new runtime.RequiredError(
                'borrowerProjectId',
                'Required parameter "borrowerProjectId" was null or undefined when calling upsertBorrowerPerson().'
            );
        }

        if (requestParameters['upsertBorrowerPersonCommandDto'] == null) {
            throw new runtime.RequiredError(
                'upsertBorrowerPersonCommandDto',
                'Required parameter "upsertBorrowerPersonCommandDto" was null or undefined when calling upsertBorrowerPerson().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/emprunteurs/projets-emprunts/{borrowerProjectId}/personnes`.replace(`{${"borrowerProjectId"}}`, encodeURIComponent(String(requestParameters['borrowerProjectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertBorrowerPersonCommandDtoToJSON(requestParameters['upsertBorrowerPersonCommandDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateOrUpdateEmprunteurPersonneResponseFromJSON(jsonValue));
    }

    /**
     * Add person to a borrower project
     */
    async upsertBorrowerPerson(requestParameters: UpsertBorrowerPersonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateOrUpdateEmprunteurPersonneResponse> {
        const response = await this.upsertBorrowerPersonRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
